/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_Visible_HintInputs */

const cs_calendar_sync_visible_hint = /** @type {(inputs: Calendar_Sync_Visible_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odešle úkoly v aktuálním rozsahu Moje / Tým / Vše do připojeného kalendáře každého řešitele.`)
};

const en_calendar_sync_visible_hint = /** @type {(inputs: Calendar_Sync_Visible_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushes tasks in the current Mine / Team / All range to each assignee’s connected calendar.`)
};

/**
* | output |
* | --- |
* | "Pushes tasks in the current Mine / Team / All range to each assignee’s connected calendar." |
*
* @param {Calendar_Sync_Visible_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_visible_hint = /** @type {((inputs?: Calendar_Sync_Visible_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_Visible_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_visible_hint(inputs)
	return cs_calendar_sync_visible_hint(inputs)
});